import { render, staticRenderFns } from "./AdminTestimonyNewPage.vue?vue&type=template&id=a5396c24"
import script from "./AdminTestimonyNewPage.vue?vue&type=script&lang=js"
export * from "./AdminTestimonyNewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports